import Box from "@mui/material/Box";
import contact_img from '~/assets/images/contact_img.png';
import ListArticle from "../components/ListArticle";

const ExamNotice = () => {


    return (
        <Box sx={{ mt: 2, pb: 6 }}>
            <Box
                sx={{
                    minHeight: 250,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    color: 'white',
                    fontSize: 26,
                    fontWeight: 'bold',
                    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${contact_img})`,
                    backgroundPosition: 'center',
                    textAlign: "center"
                }}>
                THÔNG BÁO THI CHỨNG CHỈ ỨNG DỤNG CÔNG NGHỆ THÔNG TIN
            </Box>

            <ListArticle category='Thông báo thi' />

        </Box>

    )
}

export default ExamNotice;